import { React, useEffect, useState} from "react";
import { getDynamicIds } from "../getData";
import "../../styles/InfoInicio.css";
import gmoLogo from "../../assets/images/gmo_logo.png";

const InfoInicio = () => {

  const [ texto, setTexto ] = useState("");
  useEffect(() => {
    const { paisId, cadenaId } = getDynamicIds();
    const textos = {
      2: "¡Agenda tu examen visual en GMO Chile ahora mismo!",
      1: "Agenda tu cita de salud visual en GMO Perú hoy mismo",
      3: "Reserva tu examen visual en GMO Colombia en minutos",
      4: "Solicita tu examen visual en GMO Ecuador hoy mismo"
    };
    if (paisId && cadenaId === 1){
      setTexto(textos[paisId]);
    }
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="col-12 pads30 pads10-768 mb20 mt20">
          <div className="row d-flex align-items-center">
            <div className="col-auto">
              <img
                src="/static/media/gmo_logo.2f012cd8d03f7220387a.png"
                alt="GMO logo"
                className="img-fluid"
                style={{ maxWidth: "100px", maxHeight: "30px" }}
              />
            </div>
            <div className="col">
              {(texto && texto.trim() !== "") && (
                <div className="h-seo-desc">
                  <h1>
                    {texto}
                  </h1>
                </div>
              )}
              <h2 className="upper monts-l">
                <span className="monts-b">Programe un examen de la vista</span>{" "}
                para usted y su familia
              </h2>
              <p>
                Reserve su fecha y horario preferido en su tienda más cercana
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 pl30 pr15 pads10-768">
          <div className="row booking-guide">
            <div className="col-md-2 pads5 text-center">
              <p className="upper mb0 mb20-768">
                <b>Cómo agendar</b>
              </p>
            </div>
            <div className="col-md col-4 col-book-steps">
              <img
                src="https://cdn.shopify.com/s/files/1/0015/7610/8121/files/ico_gmo1.png?v=1724945945"
                className="img-book-step"
                alt="Imagen agendamiento 1"
              />
              <p className="mb0">
                <b>1.</b> SELECCIONA LA TIENDA DONDE TE QUIERES ATENDER
              </p>
            </div>
            <div className="col-md col-4 col-book-steps">
              <img
                src="https://cdn.shopify.com/s/files/1/0015/7610/8121/files/ico_gmo2.png?v=1724945945"
                className="img-book-step"
                alt="Imagen agendamiento 2"
              />
              <p className="mb0">
                <b>2.</b> SELECCIONA EL SERVICIO DESEADO
              </p>
            </div>
            <div className="col-md col-4 col-book-steps">
              <img
                src="https://cdn.shopify.com/s/files/1/0015/7610/8121/files/ico_gmo3.png?v=1724945945"
                className="img-book-step"
                alt="Imagen agendamiento 3"
              />
              <p className="mb0">
                <b>3.</b> SELECCIONA LA FECHA E INGRESA TUS DATOS PARA CONFIRMAR
                LA CITA
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoInicio;
